import React from 'react';
import HeaderV3 from '../../components/HeaderV3/headerV3.component';
import SolutionsHeroSection from './solutions-components/SolutionsHeroSection/solutionsherosection.componenet';
import PreventNDTFailuresSection from './solutions-components/PreventNDTFailuresSection/preventNDTfailuressection.component';
import ExpertOversightSection from './solutions-components/ExpertOversightSection/expertoversightsection.component';
import AIforExpertsSection from './solutions-components/AIforExpertsSection/aiforexpertssection.component';
import HowOrbixWorksSection from './solutions-components/HowOrbixWorksSection/howorbixworkssection.component';
import PrecisionAuditAssetsSection from './solutions-components/PrecisionAuditAssetsSection/precisionauditassetssection.component';
import ProblemSection from './solutions-components/ProblemSection/problemsection.component';
import OrbixContact from '../../components/ContactSection/contact.component';
import FooterSection from '../../components/FooterSection/footersection.component';
import { Fragment } from "react";


function Solutions() {
  return (
    <Fragment>
    {/* main */}
    <main className="page-wrapper dark-mode">
    {/* Header  */}
    <HeaderV3 />

    {/* Hero  */}
    <SolutionsHeroSection />

    
    {/* Prevent NDT Failures Section  */}
    <PreventNDTFailuresSection/>


    {/*Expert Oversight Section  */}
    <ExpertOversightSection/>

     {/*AI for Experts Section  */}
     <AIforExpertsSection/>

    {/*How Orbix Works Section  */}
    <HowOrbixWorksSection/>
    
    
    {/* Precision Audit Assets Section  */}
    <PrecisionAuditAssetsSection/>

    {/*Problem Section  */}
    <ProblemSection/>
     

    



    {/* Contact -1 */}
    <OrbixContact/>

    <FooterSection />
    </main>

    </Fragment>
  )
}

export default Solutions